import React from 'react';
import { SignedIn, SignedOut, SignInButton, SignUpButton, UserButton } from '@clerk/clerk-react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import Pricing from './pages/Pricing';
import DataMethodology from './pages/DataMethodology'; // Import the new component
import Solutions from './pages/Solutions'; // Import the new component
import SignUpPage from './pages/SignUp';

function App() {
  return (
      <Router>
        <header style={{ padding: '0.75rem 1rem', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <SignedOut>
            <SignInButton
              signUpUrl="/sign-up"
              // Use new redirect props
              signInForceRedirectUrl="/dashboard"
              signUpForceRedirectUrl="/dashboard"
            />
            <SignUpButton
              signUpUrl="/sign-up"
              // Use new redirect props
              signUpForceRedirectUrl="/dashboard"
            />
          </SignedOut>
          <SignedIn>
            <UserButton />
          </SignedIn>
        </header>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/data-methodology" element={<DataMethodology />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/* Catch-all redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
  );
}

export default App;
